import React, { useState, useEffect } from "react";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import DataTable_Component from "../../components/charginglocation/Data Table";
import Status_modal from "../../components/manageInvoice/status_modal/index";
import Update_data_modal from "../../components/manageInvoice/update_data_modal/index";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faPenToSquare,
  faTrash,
  faEnvelope,
  faCopy,
} from "@fortawesome/free-solid-svg-icons";
import Add_data_modal from "../../components/charginglocation/update_data_modal";
import Layouts from "../../layouts/layouts";
import DamageDetailModal from "../../components/charginglocation/Charging Details";
import * as XLSX from "xlsx"; // Import XLSX library for Excel export

export default function Charginglocation() {
  const title = "Charging Location Details";
  const [apistate, setApiState] = useState([]);
  const [apicol, setApiCol] = useState([]);
  const [selectVal, setSelectval] = useState([]);
  const [openModal, setOpenModal] = useState(true);
  const [selectVal_details, setSelectVal_details] = useState([]);
  const [details_modal_show, set_details_modal_Show] = useState(false);

  const [open_add_modal, setOpen_add_modal] = useState({
    render: true,
    modal_open: false,
  });

  const [open_update_modal, setOpen_update_modal] = useState({
    render: true,
    modal_open: false,
  });
  const [update_modal_data, setUpdate_modal_data] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [showDamageDetailModal, setShowDamageDetailModal] = useState(false);
  const [selectedDamage, setSelectedDamage] = useState(null);

  const brad = [
    {
      name: "Home",
    },
    {
      name: title,
    },
  ];
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const columns = [
    {
      name: <b>Vehicle</b>,
      selector: (row) => row.vehicle_id?.numberplate || "N/A",
      sortable: true,
    },
    {
      name: <b>Total Locations</b>,
      selector: (row) => row.charging_locations?.length || 0,
      sortable: true,
    },
    {
      name: <b>Charging Location's</b>,
      cell: (row) => (
        <div
          style={{
            maxWidth: "250px",
            whiteSpace: "normal",
            wordBreak: "break-word",
          }}
        >
          {row.charging_locations && row.charging_locations.length > 0
            ? row.charging_locations.map((loc, index) => (
                <div key={index}>
                  <strong>{index + 1}.</strong> {loc.location_name || "N/A"}
                </div>
              ))
            : "N/A"}
        </div>
      ),
      sortable: false,
    },

    {
      name: <b>Latitude</b>,
      cell: (row) => (
        <div
          style={{
            maxWidth: "200px",
            whiteSpace: "normal",
            wordBreak: "break-word",
          }}
        >
          {row.charging_locations && row.charging_locations.length > 0
            ? row.charging_locations.map((loc, index) => (
                <div key={index}>
                  <strong>{index + 1}.</strong> {loc.latitude ?? "N/A"}
                </div>
              ))
            : "N/A"}
        </div>
      ),
      sortable: false,
    },

    {
      name: <b>Longitude</b>,
      cell: (row) => (
        <div
          style={{
            maxWidth: "200px",
            whiteSpace: "normal",
            wordBreak: "break-word",
          }}
        >
          {row.charging_locations && row.charging_locations.length > 0
            ? row.charging_locations.map((loc, index) => (
                <div key={index}>
                  <strong>{index + 1}.</strong> {loc.longitude ?? "N/A"}
                </div>
              ))
            : "N/A"}
        </div>
      ),
      sortable: false,
    },

    {
      name: <b>Action</b>,
      cell: (row) => (
        <>
          <button
            onClick={() => setUpdateStoreBtn(row)}
            className="btn btn-info btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faPenToSquare} />
          </button>
          <button
            onClick={() => delete_row(row)}
            className="btn btn-danger btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>
        </>
      ),
    },
  ];

  const handleShow = (row) => {
    setOpenModal(!openModal);
    setSelectval(row);
  };

  const fetchCharging = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v4/charging-data`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const chargingData = response.data?.data;

      if (Array.isArray(chargingData)) {
        setApiState(chargingData);
      } else {
        console.error("Unexpected data format from API", response.data);
      }

      setApiCol(columns);
    } catch (error) {
      console.error("Error fetching Charging Data:", error);
    }
  };

  useEffect(() => {
    fetchCharging(currentPage);
  }, [currentPage]);

  const setStoreBtn = () => {
    setOpen_add_modal({ render: !open_add_modal.render, modal_open: true });
  };

  const setUpdateStoreBtn = (row) => {
    setOpen_update_modal({
      render: !open_update_modal.render,
      modal_open: true,
    });
    setUpdate_modal_data(row);
  };

  const copyLink = () => {
    alert(46);
  };

  const delete_row = (row) => {
    Swal.fire({
      icon: "warning",
      title: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }

        const vehicleId = row?.vehicle_id?._id;
        if (!vehicleId) {
          Swal.fire("Error!", "Vehicle ID not found.", "error");
          return;
        }

        axios
          .delete(
            `${process.env.REACT_APP_BASE_URL}/api/v4/charging-data/${vehicleId}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then(() => {
            Swal.fire("Deleted!", "Charging data has been deleted.", "success");
            fetchCharging(currentPage);
          })
          .catch((error) => {
            Swal.fire("Error!", "Charging data could not be deleted.", "error");
            console.error("Error deleting charging data:", error);
          });
      }
    });
  };

  const updateCharging = (updatedCharging) => {
    setApiState((prev) =>
      prev.map((charging) =>
        charging._id === updateCharging._id ? updateCharging : charging
      )
    );
  };

  const exportToExcel = () => {
    const transformedData = apistate.flatMap((entry) => {
      const vehicleNumber = entry.vehicle_id?.numberplate || "No Plate";

      // If there are multiple charging locations, we create a row per location
      return entry.charging_locations.map((location, index) => ({
        "Vehicle Number": vehicleNumber,
        "Location Name": location.location_name || "No Location Name",
        Latitude: location.latitude,
        Longitude: location.longitude,
        Timestamp: location.timestamp
          ? new Date(location.timestamp).toLocaleString()
          : "No Timestamp",
      }));
    });

    const worksheet = XLSX.utils.json_to_sheet(transformedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Charging");

    XLSX.writeFile(workbook, "charging.xlsx");
  };

  return (
    <>
      <Layouts />
      <Status_modal row={selectVal} openModal={openModal} />
      <Add_data_modal
        select_data={update_modal_data}
        open_update_data_modal={open_update_modal}
        onUpdateCharging={updateCharging}
      />

      <div className="container-fluid">
        <div className="row my-3">
          <div className="col-12">
            <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
              <div className="card-header d-flex justify-content-between border-bottom pb-1">
                <h4>{title}</h4>
                <div>
                  <Link to="/create_charginglocation">
                    <div className="btn btn-info btn-sm text-white me-2">
                      Add Charging Location
                    </div>
                  </Link>
                  <button
                    onClick={exportToExcel}
                    className="btn btn-success btn-sm text-white"
                  >
                    Export to Excel
                  </button>
                </div>
              </div>

              <div className="card-body">
                {apistate.length > 0 ? (
                  <DataTable_Component
                    searchBy="numberplate"
                    title_btn={true}
                    apidata={apistate}
                    // columns={apicol}
                    columns={columns}
                  />
                ) : (
                  <p>Loading...</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
